import React, { useState, useCallback } from 'react';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@mui/styles';
import {
    Link,
    Typography,
    colors,
} from '@mui/material';

const useStyles = makeStyles(theme => ({
    root: {},
    dropZone: {
        border: `1px dashed ${theme.palette.divider}`,
        padding: theme.spacing(6),
        outline: 'none',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: colors.grey[50],
            opacity: 0.5,
            cursor: 'pointer',
        },
    },
    dragActive: {
        backgroundColor: colors.grey[50],
        opacity: 0.5,
    },
    image: {
        width: 130,
    },
    info: {
        marginTop: theme.spacing(1),
    },
    list: {
        maxHeight: 320,
    },
    actions: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'flex-end',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));

const FilesDropzone = props => {
    const {
        className,
        uploadFile = () => { },
        accept = "image/*,video/*",
        multiple = false,
        maxFiles,
        ...rest
    } = props;

    const classes = useStyles();

    const [files, setFiles] = useState([]);

    const handleDrop = useCallback(acceptedFiles => {
        uploadFile(acceptedFiles);
        // setFiles(files => [...files].concat(acceptedFiles));
    }, []);

    const handelClickUpload = () => {
        uploadFile(files)
    }

    const handleRemoveAll = () => {
        setFiles([]);
    };

    let config = {
        onDrop: handleDrop,
        multiple,
        // accept,
    }

    if (maxFiles) {
        config.maxFiles = maxFiles;
    }

    const { getRootProps, getInputProps, isDragActive } = useDropzone(config);

    return (
        <div {...rest} className={clsx(classes.root, className)}>
            <div
                className={clsx({
                    [classes.dropZone]: true,
                    [classes.dragActive]: isDragActive,
                })}
                {...getRootProps()}
            >
                <input {...getInputProps()} />
                <div>
                    <img alt="Select file" className={classes.image} src="/images/undraw_add_file2_gvbb.svg" />
                </div>
                <div>
                    <Typography gutterBottom variant="h3">
                        Select files
                    </Typography>
                    <Typography className={classes.info} color="textSecondary" variant="body1">
                        Drop files here or click <Link underline="always">browse</Link> thorough your machine
                    </Typography>
                </div>
            </div>
            {/* {files.length > 0 && (
                <Fragment>
                    <PerfectScrollbar options={{ suppressScrollX: true }}>
                        <List className={classes.list}>
                            {files.map((file, i) => (
                                <ListItem divider={i < files.length - 1} key={uuid()}>
                                    <ListItemIcon>
                                        <FileCopyIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={file.name}
                                        primaryTypographyProps={{ variant: 'h5' }}
                                        secondary={bytesToSize(file.size)}
                                    />
                                    <Tooltip title="More options">
                                        <IconButton edge="end" size="large">
                                            <MoreIcon />
                                        </IconButton>
                                    </Tooltip>
                                </ListItem>
                            ))}
                        </List>
                    </PerfectScrollbar>
                    <div className={classes.actions}>
                        <Button onClick={handleRemoveAll} size="small">
                            Remove all
                        </Button>
                        <Button color="secondary" size="small" variant="contained" onClick={handelClickUpload}>
                            Upload files
                        </Button>
                    </div>
                </Fragment>
            )} */}
        </div>
    );
};

export default FilesDropzone;
